export default {
  /**
   * Obtener la ruta actual del state
   */
  getRoute: state => () => state.route,
  /**
   * Obtener la respuesta mockeada
   */
  getMock: state => () => state.mock,
  /**
   * Obtener la ruta actual del state
   */
  getIsExceeded: state => () => state.isExceeded,
  /**
   * Obtener el model + datos del paso 1
   */
  getPaso1: state => () => state.paso1,
  /**
   * Obtener el model + datos del paso 2
   */
  getPaso2: state => () => state.paso2,
  /**
   * Obtener el model + datos del paso 3
   */
  getPaso3: state => () => state.responseOferta.respuesta.oferta,
  /**
   * Obtener el model + datos del paso 4
   */
  getPaso4: state => () => {
    let { paso1 } = state;
    let datosPrecargados = {
      phone: { area: paso1.phone.area, numero: paso1.phone.numero },
      email: paso1.email
    };

    return { ...state.paso4, ...datosPrecargados };
  },
  /**
   * Obtener el model + datos de gracias
   */
  getGracias: state => () => ({
    isExceeded: state.isExceeded,
    nombre: state.paso1.nombre
  }),

  /** Reactivo Web */
  getPaso1Reactivo: state => () => state.reactivo.paso1,
  getOrigen: state => () => state.origen,
  getOfertaReactivo: state => () => state.reactivo.oferta,
  getAdobeTargetExperience: state => () => state.adobeTargetExperience,

  /** Agro **/
  getAgroCuitValidado: state => state.cuitAgroValidado,
  getAgroData: state => () => state.agroData,
  getOfertaAgro: state => () => state.ofertaAgro,
  getTelefonoVerificado: state => () => state.telefonoVerificado,
  getEmailVerificado: state => () => state.emailVerificado,
  getAgroError: state => () => state.agroError
};
